import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth, useLoginWithRedirect } from '@frontegg/react';

import { SignIn } from '~/auth';
import { SettingsPage } from '~/settings';
import FleetManagerRoutes from '~/fleet-manager/FleetManagerRoutes';

import Layout from './Layout';

function RequireAuth({ children }: { children: JSX.Element }) {
  const { user, isAuthenticated } = useAuth();
  const loginWithRedirect = useLoginWithRedirect();

  if (user && isAuthenticated) {
    return children;
  }

  loginWithRedirect();

  return null;
}

function MainRoutes() {
  const { user } = useAuth();
  if (user?.accessToken) localStorage.setItem('token', user?.accessToken);
  return (
    <Layout>
      <Routes>
        <Route index element={<Navigate to="fleet-manager" />} />
        <Route path="fleet-manager/*" element={<FleetManagerRoutes />} />
        <Route path="settings" element={<SettingsPage />} />
      </Routes>
    </Layout>
  );
}

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="auth/*" element={<SignIn />} />
      <Route
        path="/*"
        element={
          <RequireAuth>
            <MainRoutes />
          </RequireAuth>
        }
      />
    </Routes>
  );
}
